import { render, staticRenderFns } from "./IconEducation.vue?vue&type=template&id=35223b68&scoped=true&"
import script from "./IconEducation.vue?vue&type=script&lang=js&"
export * from "./IconEducation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35223b68",
  null
  
)

export default component.exports